const Info = [
    {title:"Web Design",
    img:'comImages/image1.jpg',
        info:"Get high-quality web design services at an affordable rate of only $60 per hour."},

    {title:"Graphic Design",
    img:'comImages/image2.jpg',
        info:"Transform your brand with professional graphic design starting at just $25/hour.Contact us today to get started!"},

    {title:"Web development",
    img:'comImages/image3.jpg',
        info:'Transform your online presence with our professional web development services, starting at just $2,000. Cost may vary depending on the complexity of the website'},
    
    {title:"Photo Editing",
    img:'comImages/image4.jpg',
    info:"Upgrade your photos with professional editing starting at $10. Get stunning results with our experienced team. Contact us to get started"},

    {title:"IT consultation",
    img:'comImages/image5.jpg',
    info:"Get customized IT consultation services for only $50. Our expert team will help you achieve your goals. Contact us today to schedule your consultation!"},
    
    {title:"Micro Services",
    img:'comImages/image6.jpg',
        info:"Get custom microservice development starting at $1,500. Our experienced team will create efficient and scalable microservices that drive results. Contact us now to take your business to the next level!"}
        
    ]

    export default Info